//Reducers can be viewed simply as functions that return some data. All these small pieces of data can be used in App wherever required by importing respective Reducers.
import * as _ from 'lodash';
const initialState = {
	list: [],
	isLoading: true,
	taxyear: false,
	reportData: []
};

export default function (state: any = initialState, action: Function) {
	if (action.type === 'FETCH_LIST_SUCCESS') {
		return {
			...state,
			list: action.list
		};
	}
	if (action.type === 'LIST_IS_LOADING') {
		return {
			...state,
			isLoading: action.isLoading
		};
	}

	if (action.type == 'REPORTS_FILTERS_LOADED') {
		//console.log('REPORTS_FILTERS_LOADED', action.filters, state.taxyear);
		if (state.taxyear) {
			//find the correct filter
			const filter = _.find(action.filters, { taxyear: state.taxyear });
			__DEV__ && console.log('reducer found filter', filter, state.taxyear, action.filters);
			if (filter)
				return {
					...state,
					filters: action.filters,
					filter: filter
				};
		}
		return {
			...state,
			filters: action.filters
		};
	}

	if (action.type == 'SET_TAXYEAR') {
		__DEV__ && console.log('SET_TAXYEAR', state.filters, action);
		//may or may not have filter in full. May or may not have filters already in this store
		if (action.filter) {
			if (!action.filter.taxyear)
				//it's a month or something
				return {
					...state,

					filter: action.filter
				};
			return {
				...state,
				taxyear: action.filter.taxyear,
				filter: action.filter
			};
		}
		if (state.filters) {
			//look up
			const filter = _.find(state.filters, { taxyear: action.taxyear });
			__DEV__ && console.log('reducer found filter', filter);
			if (filter)
				return {
					...state,
					taxyear: action.taxyear,
					filter
				};
		}
		return {
			...state,
			taxyear: action.taxyear
		};
	}

	if (action.type === 'Init/InitLoad') {
		//catch the initial load; set taxyear to latest
		const selYear = action.data.yrs && action.data.yrs.slice(-1)[0].taxyear;

		return {
			...state,
			taxyear: selYear
		};
	}

	if (action.type == 'REPORTS_LOADED') {
		return {
			...state,
			reports: action.entries
		};
	}
	if (action.type == 'REPORT_LOADED') {
		const rep = action.report;
		var reportData = state.reportData;
		reportData[rep] = action.data;
		return {
			...state,
			reportData: { ...reportData }
		};
	}
	return state;
}

/*
In case an Action is dispatched from any point in the App, the action will be sent to all Reducers that we have created.

var gitRepos= [];
export default function(state=gitRepos, action){
  switch (action.type) {
    case "Get_Repos": { gitRepos = action.payload;
      console.log(action, 'action');
      return gitRepos;
    }
    break;
  }
  return gitRepos;
}*/
